<template>
    <AnalysisPane
      :community="community"
      :project="project"
      :get_kpi_fn="fetchExpositionKPIs"
    >
          <template v-if="kpis">
            <v-row class="project-cards__row row">
                <v-col class="col-lg-6">
                    <ProjectCard
                            title="Exposition index"
                            subtitle=""
                            hint>
                        <div class="text-center communityIndex">{{ round(kpis.expositionIndex.Community) }}%</div>
                        <div class="d-flex justify-center">
                            <table>
                                <tr :key=r v-for="r in humanRows">
                                    <td :key=c v-for="c in humanColumns">
                                            <img :class="humanClass(r, c)" :src="require('@/assets/img/icons/human.svg')"/>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="text-center panelIndex">Panel: {{ round(kpis.expositionIndex.Panel) }}%</div>
                        <template v-slot:tooltip>
                           Share of members from the Audience Community who follow a member from the Source Community.
                        </template>
                        <template v-slot:hint>
                           {{ round(kpis.expositionIndex.Community) }}% of {{ community }} may have been exposed to {{ exposedTo }}.
                        </template>
                    </ProjectCard>

                </v-col>
                <v-col class="col-lg-6">
                    <ProjectCard
                            title="Intensity"
                            hint>
                        <template v-slot:tooltip>
                            The Exposition Intensity shows for each day
                            the average number of messages that member of Audience Community
                            might have seen from the Source Community.
                        </template>
                        <div>
                            <span> Community average daily messages: {{ round(kpis.intensity.Community.average) }}</span><br>
                            <span> Panel average daily messages: {{ round(kpis.intensity.Panel.average) }}</span>
                        </div>
                        <Plotly :data="lplotlify(kpis.intensity)" :layout="chattinessInTimeLayout()"/>

                        <template v-slot:hint>
                          Among the members of {{ community }} who are exposed
                          to {{ exposedTo }}, the exposition intensity averages
                          {{ avg(kpis.intensity.Community.data) }} messages per user per day. 
                        </template>
                    </ProjectCard>
                </v-col>
            </v-row>
          </template>
    </AnalysisPane>
</template>

<script>
    import _ from "lodash";
    import ProjectCard from "./../ProjectCard";
    import CommunityService from "../../../services/community.service";
    import {Plotly} from 'vue-plotly'
    import AnalysisPane from "./AnalysisPane"


    export default {
        name: "Exposition",
        components: {ProjectCard, Plotly, AnalysisPane},
        props: ["community", "project", "exposedTo"],
        data: () => ({
            CommunityService,
            kpis: null,
            humanColumns: 8,
            humanRows: 4,
        }),
        methods: {
            humanClass (row, column) {
                let z = this.humanColumns*this.humanRows
                console.log(z)
                if (100*((row-1) * this.humanColumns + column) / z < this.kpis.expositionIndex.Community) {
                    return "human-icon"
                } else {
                    return "human-icon--panel"
                }
            },
            stickman(c) {
                let k = _.min([Math.floor(c / 10), 101])
                return _.range(k)
            },
            avg (xs) {
                console.log(_.map(xs, e => e.y))
                return _.round(_.mean(_.map(xs, e => e.y)), 2)
            },
            _lPlotlify(d, name) {
                return {
                    x: _.map(d.data, e => e.x),
                    y: _.map(d.data, e => e.y),
                    type: "scatter",
                    name: name,
                    hovertemplate: "%{y:.2f}%"
                }
            },
            lplotlify(d) {
                return d ? [this._lPlotlify(d.Community, "Community"),
                    this._lPlotlify(d.Panel, "Panel")] : []
            },
            round(x) {
                return Number.parseFloat(x).toFixed(1)
            },
            round2(x) {
                return Number.parseFloat(x).toFixed(2)
            },
            chattinessInTimeLayout() {
                return {
                    yaxis: {
                        title: "Average daily messages"
                    },
                    hovermode: 'closest'
                }
            },
            hintForActivity(c) {
                let cmax = _.maxBy(c.Community, v => v.y)
                if (cmax.x === "<1") {
                    return `The majority of members (${this.round(cmax.y)}%) publish less than 1 message per day.`
                } else if (cmax.x === "1-5") {
                    return `The majority of members (${this.round(cmax.y)}%) publish between 1 and 3 messages per day.`
                } else {
                    return `The majority of members (${this.round(cmax.y)}%) publish more than 5 messages per day.`
                }
            },
            fetchExpositionKPIs() {
              var cs = new CommunityService();
              return cs.getExpositionKPIs(
                  {
                      startDate: this.project.timeframe_start,
                      endDate: this.project.timeframe_end,
                      query: this.community,
                      exposed_to: this.exposedTo
                  },
                  null
              ).then(resp => {
                  // Only 200 gives real data
                  if (resp.status == 200) {
                    this.kpis = resp.data
                  }
                  return resp;
              })
            }
        },
    }
</script>

<style scoped>
    .inner-text {
        height: 100%;
        width: 100%;
        margin-top: 85px

    }

    .inner-text span {
        max-width: 200px;
        display: flex;
        align-items: center;
        justify-content: center
    }

    .kpi-value {
        align-items: center;
        justify-content: center;
        text-align: center
    }

    .communityIndex {
        font-size: 240%;
        color: #0499fe;
    }
    .panelIndex {
        margin-top: 10px;
        color: #8798ad;
    }

</style>
